
import React, { } from "react";
import { Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { documentLabelPanelAction } from "../../../context/actions/documentLabelPanelAction";
import "../index.scss";
import TermContactCookie from "../TermContactCookie";


const CookieNotice = () => {

    const documentLabelPanelOnState = useSelector(state => state.documentLabelPanelReducer.documentLabelPanelOn);
    const dispatch = useDispatch();

    const documentLabelPanelHandler = () => {
        dispatch(documentLabelPanelAction(!documentLabelPanelOnState))
    }
    const overlayHandler = () => {
        dispatch(documentLabelPanelAction(false))
    }
    return (



        <div className="cookie-notice-page">
            <section className="content-section">
                <div className="content-section-md">
                    <p>
                        Unless otherwise expressly stated, capitalized terms in this Cookie Notice have the same meaning as defined in the <a href="#privacyNotice">Privacy Notice</a>. Please see section below for further details.
                    </p>
                </div>
                <div className="content-section-md">
                    <h2>Learn More About Cookies</h2>
                    <ul>
                        <li>
                            <a href="#section1">Scope of Notice</a>
                        </li>
                        <li>
                            <a href="#section2">What are Cookies and How They are Used</a>
                        </li>
                        <li>
                            <a href="#section3">Your Choices About Cookies and Related Technologies</a>
                        </li>
                        <li>
                            <a href="#section4">Your Choices About Online Ads</a>
                        </li>
                        <li>
                            <a href="#section5">
                                Changes to This Notice
                            </a>
                        </li>
                        <li>
                            <a href="#contactUs">
                                How to Contact Us
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="content-section-md">
                    <h2>Additional Notices</h2>
                    <div className="content-section-inner">
                        <h4>California Privacy Disclosures</h4>
                        <p>
                            These additional California Privacy Disclosures supplement the information contained in the <a href="#privacyNotice">TRAINED Privacy Notice</a>. These Disclosures apply solely to our processing of personal information of individual residents of the State of California within the scope of the California Consumer Privacy Act of 2018 (CCPA).
                        </p>
                    </div>
                    <div className="content-section-inner" id="privacyNotice">
                        <h4>TRAINED Privacy Notice </h4>
                        <p>
                            At TRAINED, we understand that your privacy is an important part of the trust you place in us. This Notice explains how we collect, use, disclose, and otherwise process personal information in connection with our services.
                        </p>
                    </div>
                </div>
            </section>
            <section className="content-section" id="section1">
                <h2>Scope of Notice</h2>
                <p>
                    This Cookie Notice supplements the information contained in our <a href="#privacyNotice">Privacy Notice</a>  by explaining how we and our business partners and services providers use cookies and related technologies in the course of managing and providing our online services and our communications to you. It explains what these technologies are and why we use them, as well as your rights to control our use of them.
                </p>
                <p>
                    In some cases, we may use cookies and related technologies described in this Cookie Notice to collect personal information, or to collect information that becomes personal information if we combine it with other information. For more details about how we process your personal information, please review our <a href="#privacyNotice">Privacy Notice</a>.
                </p>
            </section>
            <section className="content-section" id="section2">
                <h2>What Are Cookies and How Are They Used</h2>
                <p>
                    Cookies are small data files placed on your computer or device, our online services or our emails that allow us or our third-party providers to collect certain information about your interactions with our emails, our online services and other websites you may visit.  We and our third-party providers may use other, related technologies from time to time, like web beacons, pixels, embedded scripts, location-identifying technologies and logging technologies to collect additional information about your online activity.
                </p>
                <div className="bullet-items">
                    <p>We use the information collected through these technologies to:</p>
                    <ul>
                        <li>
                            Remember information so that you will not have to re-enter it during your current or next visit to our online services;
                        </li>
                        <li>
                            Provide and monitor the effectiveness of our online services;
                        </li>
                        <li>
                            Monitor aggregate metrics such as total number of visitors, traffic, and usage patterns on our online services;
                        </li>
                        <li>
                            Diagnose or fix technology problems;
                        </li>
                        <li>
                            Plan for and enhance our online services;
                        </li>
                        <li>
                            Otherwise fulfill or support the use of personal information identified in the <a href="">Our Use of Personal Information</a> section of our Privacy Notice.
                        </li>
                    </ul>
                </div>
            </section>
            <section className="content-section" id="section3">
                <h2>Your Choices About Cookies and Related Technologies</h2>
                <div className="bullet-items">
                    <p>If you would prefer not to accept cookies, most browsers will allow you to:</p>
                    <ul>
                        <li>
                            change your browser settings to notify you when you receive a cookie, which lets you choose whether or not to accept it;
                        </li>
                        <li>
                            disable existing cookies; or
                        </li>
                        <li>
                            set your browser to automatically reject cookies.
                        </li>
                    </ul>
                    <p>
                        Please note that doing so may negatively impact your experience using our online services, as some features and options on our online services may not work properly. Depending on your device and operating system, you may not be able to delete or block all cookies. In addition, if you want to reject cookies across all your browsers and devices, you will need to do so on each browser on each device you actively use. You may also set your email options to prevent the automatic downloading of images that may contain technologies that would allow us to know whether you have accessed our email and performed certain functions with it.

                    </p>
                    <p>
                        Please note that we use Google Analytics and other Google technologies to automatically collect much of the personal information described in this section. You can learn more about Google’s practices with Google Analytics by visiting Google’s privacy policy <a href="">here</a>.  You can also view Google’s currently available opt-out options <a href="">here</a>.
                    </p>
                </div>
            </section>
            <section className="content-section" id="section4">
                <h2>Your Choices About Online Ads</h2>
                <div className="bullet-items">
                    <p>We support the self-regulatory principles for online advertising published by the Digital Advertising Alliance (DAA). This means that we allow you to exercise choice regarding the collection of information about your online activities over time and across third-party websites for online interest-based advertising purposes. More information about these principles can be found at <a href="www.aboutads.info/">www.aboutads.info/</a>. If you want to opt out of receiving online interest-based advertisements on your internet browser from advertisers and third parties that participate in the DAA program and perform advertising-related services for us and our partners, please follow the instructions at <a href="www.aboutads.info/choices">www.aboutads.info/choices</a> or <a href="http://www.networkadvertising.org/choices/">http://www.networkadvertising.org/choices/</a> to place an opt-out cookie on your device indicating that you do not want to receive interest-based advertisements.  Opt-out cookies only work on the internet browser and device they are downloaded onto. If you want to opt out of interest-based advertisements across all your browsers and devices, you will need to opt out on each browser on each device you actively use. If you delete cookies on your device generally, you will need to opt out again.</p>
                    <p>
                        If you want to opt out of receiving online interest-based advertisements on mobile apps, please follow the instructions at <a href="http://www.aboutads.info/appchoices">http://www.aboutads.info/appchoices</a>.
                    </p>
                    <p>
                        Please note that when you opt out of receiving interest-based advertisements, this does not mean you will no longer see advertisements.  It means that the online ads that you do see from DAA program participants should not be based on your interests.  We are not responsible for the effectiveness of, or compliance with, any third parties’ opt-out options or programs or the accuracy of their statements regarding their programs. In addition, third parties may still use cookies and related technologies to collect information about your activity on and use of our online services, including for analytics and fraud prevention as well as any other purpose permitted under the DAA’s principles.

                    </p>
                </div>
            </section>
            <section className="content-section" id="section5">
                <h2>Changes to This Notice</h2>
                <p>
                    We may update this Cookie Notice from time to time. When we make changes to this Cookie Notice, we will change the date at the end of this Cookie Notice to include the "Last Updated" date. If we make material changes to this Cookie Notice, we will notify you by email to your registered email address, by prominent posting on our services, or through other appropriate communication channels. All changes shall be effective from the date of publication unless otherwise provided in the notification.
                </p>
            </section>
            <TermContactCookie id="contactUs" />
        </div>





    )
};
export default CookieNotice;